export const URL_FLAG__DEBUG = "debug"
export const URL_FLAG__NOCANVAS = "nocanvas"
export const URL_FLAG__LIGHTVERSION = "light"
export const URL_FLAG__OPTION = "option"
export const URL_FLAG__ROOM_L = "r_length"
export const URL_FLAG__ROOM_W = "r_width"
export const URL_FLAG__ROOM_H = "r_height"
export const URL_FLAG__SKIP_SHAPE = "skip_shape"



export const hasUrlFlag = (name) => {
    return window.location.href.includes(name)
}

export const getUrlFlagValue = (name) => {
  if (hasUrlFlag(name)) {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }
  return null; 
};